import React, { Suspense } from 'react';
import {
    UrlRewritesComponent as SourceUrlRewritesComponent,
    ProductPage,
    CategoryPage,
    CmsPage,
    NoMatch,
} from 'SourceRoute/UrlRewrites/UrlRewrites.component';
import { UrlRewritePageType } from './UrlRewrites.config';

import './UrlRewrites.override.style';
import Loader from 'Src/component/Loader';

export {
    ProductPage,
    CategoryPage,
    CmsPage,
    NoMatch,
};

export class UrlRewritesComponent extends SourceUrlRewritesComponent {
    renderDefaultPage() {
        console.log(this.props, "===>UrlRewritesComponent");
        return null;
    }
}

export default UrlRewritesComponent;
